module.exports = __webpack_public_path__ + "img/logo_vertical.865e85a.png";